import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    // Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Upload,
    Select,
    Input,
} from 'antd';
import { 
  InboxOutlined, 
  // ExclamationCircleFilled 
} 
from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { getUserRole } from '../../Utils/Common';

const { Item } = Form;
const { Option } = Select;
const { Search } = Input;
// const { confirm } = Modal;

const Users = () => {
    const user_role = getUserRole()
    const [addVisible, setAddVisible] = useState(false);
    const [editVisible, setEditVisible] = useState(false);
    const [resetVisible, setResetVisible] = useState(false);
    const [signatureVisible, setSignatureVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userId, setUserId] = useState('');
    const [userDetails, setUserDetails] = useState({
      username: '',
      full_name:'',
      role_id:'',
      role_name: '',
    });
    const [filterConfig, setFilterConfig] = useState({
      // user_id: '',
      full_name_search: '',
    })
    const [userData, setUserData] = useState([])

    const [form] = Form.useForm();
    const [editForm] = Form.useForm();
    const [resetForm] = Form.useForm();
    const [attachmentForm] = Form.useForm();
    const { callPost, loading } = usePostRequest(()=>{
      fetchTableData()
      form.resetFields();
      editForm.resetFields();
      resetForm.resetFields();
      attachmentForm.resetFields();
      setAddVisible(false); 
      setEditVisible(false);
      setResetVisible(false);
      setSignatureVisible(false);
    });

    function ActionBtn(row) {
      const items = [
          // {
          //   key: '0',
          //   label: (
          //       <div onClick={() => showSignatureModal(row.row.id)}>
          //           E-Signature Attachment
          //       </div>
          //   ),
          // },
          {
            key: '1',
            label: (
            <div onClick={() => showResetModal(row.row.id, row.row)}>
                Reset Password
            </div>
            ),
          },
          {
            key: '2',
            label: (
              <div onClick={()=>showEditModal(row.row.id, row.row)}>
                  Edit
              </div>
            ),
          },
          // {
          //   key: '3',
          //   label: (
          //     <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
          //         Delete
          //     </div>
          //   ),
          // },
      ];

      return (
        <>
         {
           user_role === "Administrator" && (
            <span className='center'>
              <Dropdown
                menu={{
                items,
                }}
                trigger={['click']}
              >
                <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
                  <Space>
                    <MoreVert />
                  </Space>
                </div>
              </Dropdown>
            </span>
           )
         }
        </>
      );
    }

    async function fetchTableData  () {
      setIsLoading(true);

      const response = await UseGetRequest("users/get", filterConfig);
      if (response.data) {
        const user_data  = response?.data?.data?.map((info) => ({
          id: info.id,
          username: info.username,
          full_name: info.full_name,
          role_id: info.role_id,
          role_name: info.role_name,
        }))

        setUserData(user_data);
      } else {
        setUserData([])
      }

      setIsLoading(false);
    }

    // const showAddModal = () => {
    //   setAddVisible(true);
    // };

    const showEditModal = (id, user_details) => {
      setUserId(id) 
      setUserDetails(() => ({
        username: user_details.username,
        full_name: user_details.full_name,
        role_id: user_details.role_id,
        role_name: user_details.role_name,
      }));     
      editForm.setFieldsValue({
        username: user_details.username,
        full_name: user_details.full_name,
        role_id: user_details.role_id,
        role_name: user_details.role_name,
      });
      
      setEditVisible(true);
    };

    const showResetModal = (id, user_details) => {
      setUserId(id)
      setUserDetails(() => ({
        username: user_details.username,
        full_name: user_details.full_name,
        role_id: user_details.role_id,
        role_name: user_details.role_name,
      }));     
      resetForm.setFieldsValue({
        username: user_details.username,
        full_name: user_details.full_name,
        role_id: user_details.role_id,
        role_name: user_details.role_name,
      });
      setResetVisible(true);
    };
  
    // const showSignatureModal = (id) => {
    //   setUserId(id)
    //   setSignatureVisible(true);
    // };

    const handleAddCancel = () => {
      form.resetFields();
      setAddVisible(false);
    };

    const handleEditCancel = () => {
      editForm.resetFields();
      setEditVisible(false);
    };

    const handleResetCancel = () => {
      resetForm.resetFields();
      setResetVisible(false);
    };

    const handleSignatureCancel = () => {
      attachmentForm.resetFields();
      setSignatureVisible(false);
    };
  
    const handleAddOk = () => {
      form.validateFields().then(values => {
        callPost(
          "users/create", 
          values,
          false
        );
      }).catch(errorInfo => {
        toast.error('Validation Failed:', errorInfo);
      });
    };
  
    const handleEditOk = () => {
      editForm.validateFields().then(values => {
        const resetData = {
          ...values,
          user_id: userId
        }
        callPost(
          "users/update", 
          resetData,
          false
        );
      }).catch(errorInfo => {
        toast.error('Validation Failed Edit:', errorInfo);
      });
    };

    const handleResetOk = () => {
      resetForm.validateFields().then(values => {
        const resetData = {
          ...values,
          user_id: userId
        }
        callPost(
          "users/update", 
          resetData,
          false
        );
      }).catch(errorInfo => {
        toast.error('Validation Failed:', errorInfo);
      });
    };
  
    const handleSignatureOk = () => {
      attachmentForm.validateFields().then(values => {
        const myFiles = values.attachments.map((file) => {
          return file.originFileObj;
        });
        
        var finalValues = Object.entries({user_id: userId, attachments: myFiles}).map(([key, value]) => ({
          key,
          value,
        }));
        callPost(
          "users/upload_attachment", 
          finalValues,
          true
        );
      }).catch(errorInfo => {
        toast.error('Validation Failed:', errorInfo);
      });
    };

    // const showDeleteConfirm = (id) => {
    //   confirm({
    //     title: 'Are you sure delete this User?',
    //     icon: <ExclamationCircleFilled/>,
    //     okText: 'Yes',
    //     okType: 'danger',
    //     cancelText: 'No',
    //     okButtonProps: {
    //       className: 'custom-yes-button',
    //     },
    //     cancelButtonProps: {
    //       className: 'custom-no-button',
    //     },
    //     confirmLoading: loading,
    //     onOk() {
    //       callPost(
    //         "users/delete", 
    //         {user_id: id},
    //         false
    //       );
    //     },
    //   });
    // };

    const passwordValidator = (rule, value, callback) => {
      const password = form.getFieldValue('password');
      if (value && password && value !== password) {
        callback('Passwords do not match!');
      } else {
        callback();
      }
    };

    // const [fileList, setFileList] = useState([])
    const normFile = (e) => {
      if (Array.isArray(e)) {
        return e;
      }
      return e?.fileList;
    };

    const onSearch = (e) => {
      setFilterConfig(() => (
        {
          full_name_search: e.target.value || ''
        }
      ));
      fetchTableData();
    };

    useEffect(() => {
      fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Layout className='page'>
            <Navbar navKey={'user_nav'}/>
            <Layout className='content-container'>
              <Row className='custom-padding responsive-tab-inline'>
                <Col span={9} className='header-container'>
                    USER
                </Col>
                <Col span={15} className='mt-2 responsive-tab-width' align='end'>
                  <Space className='responsive-inline'>
              
                      <Search
                        placeholder="Search..."
                        size='medium'
                        onChange={(e)=>onSearch(e)}
                        className='responsive-header-input'
                      />
              
                      {/* <Button 
                        className='button-color responsive-header-btn' 
                        onClick={showAddModal} 
                        type="primary"
                      >
                        + Add User
                      </Button> */}
                  </Space>
                </Col>
              </Row>
              <Row className='page-content'>
                  <Col span={24} className='responsive-overflow-auto'>
                    <AntDTable
                      tableHeaders={[
                        "Name",
                        "Role",
                      ]}
                      headerSelector={[
                        "full_name",
                        "role_name",
                      ]}
                      tableData={userData}
                      ActionBtn={(row) => ActionBtn(row)}
                      withAction={true}
                      loading={isLoading}
                      isClickable={false}
                      tablePages={10}
                      isSearch={true}
                    />
                  </Col>
              </Row>
            </Layout>
            <Modal
                title="Add User"
                confirmLoading={loading}
                open={addVisible}
                onOk={handleAddOk}
                onCancel={handleAddCancel}
                maskClosable={false}
            >
                 <Form form={form} layout="vertical">
                    <Item
                      label="Username"
                      name="username"
                      rules={[{ required: true, message: 'Please enter your username!' }]}
                    >
                        <Input />
                    </Item>
                    <Item
                      label="Password"
                      name="password"
                      rules={[{ required: true, message: 'Please enter your password!' }]}
                    >
                        <Input.Password />
                    </Item>
                    <Item
                      label="Confirm Password"
                      name="confirm_password"
                      dependencies={['password']}
                      rules={[
                        { required: true, message: 'Please enter your confirm password!' },
                        { validator: passwordValidator }
                      ]}
                    >
                        <Input.Password />
                    </Item>
                    <Item
                      label="Full Name"
                      name="full_name"
                      rules={[{ required: true, message: 'Please enter your full name!' }]}
                    >
                        <Input />
                    </Item>
                    <Item
                      label="Role"
                      name="role_id"
                      rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
                    >
                      <Select placeholder="Select a Role">
                        <Option key='1' value="1">Administrator</Option>
                        <Option key='2' value="2">Admin Staff</Option>
                      </Select>
                    </Item>
                </Form>
            </Modal>
            <Modal
                title="Edit User"
                confirmLoading={loading}
                open={editVisible}
                onOk={handleEditOk}
                onCancel={handleEditCancel}
                maskClosable={false}
            >
              <Form 
                form={editForm} 
                layout="vertical" 
                // onFinish={onFinish}
                initialValues={userDetails}
              >
                  <Item
                    label="Username"
                    name="username"
                    rules={[{ required: true, message: 'Please enter your username!' }]}
                  >
                      <Input />
                  </Item>
                  <Item
                    label="Full Name"
                    name="full_name"
                    rules={[{ required: true, message: 'Please enter your full name!' }]}
                  >
                      <Input />
                  </Item>
                  <Item
                    label="Role"
                    name="role_id"
                    rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
                  >
                    <Select placeholder="Select a Role">
                      <Option key='1' value="1">Administrator</Option>
                      <Option key='2'  value="2">Admin Staff</Option>
                    </Select>
                  </Item>
              </Form>
            </Modal>
            <Modal
                title="Reset Password"
                confirmLoading={loading}
                open={resetVisible}
                onOk={handleResetOk}
                onCancel={handleResetCancel}
                maskClosable={false}
            >
                <Form 
                  form={resetForm} 
                  layout="vertical"
                  initialValues={userDetails}
                >
                    <Item
                      label="Username"
                      name="username"
                      initialValue={userDetails.username}
                    >
                      <Input 
                        disabled
                      />
                    </Item>
                    <Item
                      label="Password"
                      name="password"
                      rules={[{ required: true, message: 'Please enter your password!' }]}
                    >
                        <Input.Password />
                    </Item>
                    <Item
                      label="Confirm Password"
                      name="confirm_password"
                      dependencies={['password']}
                      rules={[
                        { required: true, message: 'Please enter your confirm password!' },
                        { validator: passwordValidator }
                      ]}                    
                    >
                        <Input.Password/>
                    </Item>
                </Form>
            </Modal>
            <Modal
              title="E-Signature Attachment"
              confirmLoading={loading}
              open={signatureVisible}
              onOk={handleSignatureOk}
              onCancel={handleSignatureCancel}
              maskClosable={false}
            >
              <Form form={attachmentForm} layout="vertical">
                <Form.Item label="Attachment">
                    <Form.Item 
                      name="attachments" 
                      valuePropName="fileList" 
                      getValueFromEvent={normFile} 
                      noStyle
                      rules={[{ required: true, message: 'Please upload a file' }]}
                    >
                        <Upload.Dragger 
                          listType="picture"
                          multiple={false}
                          maxCount={1}
                          name="attachments" 
                          action="/upload.do"
                          // fileList={fileList}
                          // showUploadList={false}
                          accept=".png, .jpg, .jpeg"
                        >
                          <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">Click or drag file to this area to upload</p>
                          <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                        </Upload.Dragger>
                    </Form.Item>
                </Form.Item>
              </Form>
            </Modal>
        </Layout>
    )
}

export default Users
